import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { API } from "@/lib/api";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    const exchange = async () => {
      try {
        const res = await fetch(`${API}/auth/session`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ session_id: sessionId }),
        });
        if (!res.ok) throw new Error("auth failed");
        const user = await res.json();
        const target = location.pathname && location.pathname !== "/" ? location.pathname : "/dashboard";
        navigate(target, { state: { user }, replace: true });
      } catch {
        navigate("/", { replace: true });
      }
    };
    exchange();
  }, [location, navigate]);

  return (
    <div className="min-h-screen bg-[#0E1A2B] flex items-center justify-center">
      <p
        className="font-mono text-xs uppercase tracking-[0.25em] text-slate-400 animate-pulse"
        data-testid="auth-callback-loading"
      >
        Signing you in…
      </p>
    </div>
  );
}
